import { AvField, AvForm } from "availity-reactstrap-validation"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { CardTitle, Col, Modal, ModalBody, Row } from "reactstrap"

import Select from "react-select"
import { createFollowUp, getUsers, updateFollowUp } from "store/actions"
import { useParams } from "react-router-dom/cjs/react-router-dom.min"
import { useDispatch, useSelector } from "react-redux"
import moment from "moment"
import { useRole, ROLE_TYPES } from "hooks/useRole"

const FollowUpModal = ({ show, onCloseClick, updateData, type }) => {
  const dispatch = useDispatch()
  const { isAnyRole } = useRole()
  const params = useParams()

  const { allStaffs } = useSelector(state => ({
    allStaffs: state?.Members?.users?.users,
  }))

  const [Staff, setStaff] = useState("Select Staff...")
  const [StaffId, setStaffId] = useState("")
  const [StaffSearch, setStaffSearch] = useState("")
  const [status, setStatus] = useState("")
  const [statusValue, setStatusValue] = useState("")

  const handlerStatusFinalValue = event => {
    setStatus(event?.label)
    setStatusValue(event?.value)
  }

  useEffect(() => {
    setStatus(updateData?.status)
    setStatusValue(updateData?.status)
  }, [updateData])

  const statusValues = [
    { label: "All", value: "all" },
    { label: "Scheduled", value: "scheduled" },
    { label: "Pending", value: "pending" },
    { label: "Done", value: "done" },
  ]

  useEffect(() => {
    if (
      isAnyRole([
        ROLE_TYPES.ADMIN,
        ROLE_TYPES.SUPER_ADMIN,
        ROLE_TYPES.ENQUIRY_MANAGER,
        ROLE_TYPES.ENQUIRY_ANALYST,
      ])
    ) {
      dispatch(getUsers("", "", StaffSearch, "", 'member')) // staff members only
    }
  }, [dispatch, StaffSearch])

  const staffOptions = [
    {
      label: "All",
      value: "",
    },
    {
      options: allStaffs?.map((result, index) => ({
        key: index,
        label: result?.name,
        value: result?._id,
      })),
    },
  ]

  const handleEntersStaffs = text => {
    setStaffSearch(text)
  }

  const handlerStaffsFinalValue = event => {
    setStaff(event?.label)
    setStaffId(event?.value)
  }

  useEffect(() => {
    setStaffId(updateData?.createdBy?.id)
    setStaff(updateData?.createdBy?.name)
  }, [updateData])

  const handleValidSubmit = (e, v) => {
    const followUpUpdate = {
      ...v,
      lead: params?.id,
      type: type,
      createdBy: StaffId,
      status: statusValue,
    }

    if (updateData?._id) {
      dispatch(updateFollowUp(followUpUpdate, updateData?._id, onCloseClick, "", "", params))
      onCloseClick()
    } else {
      const followUpCreate = {
        ...v,
        lead: params?.id,
        type: type,
        status: statusValue,
        createdBy: StaffId,
      }
      dispatch(createFollowUp(followUpCreate, onCloseClick, "", "", params))
      onCloseClick()
    }
  }

  const dater = dates => {
    moment(dates).format("MM/DD/YYYY")
    return dater
  }

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="p-4">
        <CardTitle className="pb-3">
          {updateData?._id ? "Edit Follow Up" : "Add New Follow Up"}
        </CardTitle>
        <AvForm
          onValidSubmit={(e, v) => {
            handleValidSubmit(e, v)
          }}
        >
          <Row>
            <>
              <Col className="col-12">
                <label>
                  Title <span className="text-danger"> *</span>
                </label>
                <AvField
                  name="title"
                  type="text"
                  placeholder="Enter title... "
                  value={updateData?.title}
                  validate={{
                    required: {
                      value: false,
                      errorMessage: "title is required",
                    },
                  }}
                />
              </Col>
              <Col className="col-12 py-3">
                <div className="w-100 text-align-center">
                  <label>Created By</label>
                  <Select
                    onInputChange={handleEntersStaffs}
                    value={Staff}
                    placeholder={Staff}
                    onChange={handlerStaffsFinalValue}
                    options={staffOptions}
                    classNamePrefix="select2-selection"
                    isLoading={false}
                  />
                </div>
              </Col>
              <Col className=" mb-4" md={updateData?._id ? 6 : 12}>
                <label>Date</label>
                <AvField
                  name="date"
                  type="date"
                  placeholder="Enter Date"
                  value={dater}
                  validate={{
                    required: {
                      value: false,
                      errorMessage: "Date is required",
                    },
                  }}
                />
              </Col>

              {updateData?._id && (
                <Col className="col-6 mb-2">
                  <label>Status</label>
                  <Select
                    // onInputChange={handleEntersVehicle}
                    value={status}
                    placeholder={status}
                    onChange={handlerStatusFinalValue}
                    options={statusValues}
                    classNamePrefix="select2-selection"
                    isLoading={false}
                  />
                </Col>
              )}
            </>
          </Row>
          <Row>
            <Col className="col-12">
              <label>
                Message <span className="text-danger"> *</span>
              </label>
              <AvField
                name="message"
                type="textarea"
                placeholder="Enter message... "
                value={updateData?.message}
                style={{ minHeight: "100px" }}
                validate={{
                  required: {
                    value: false,
                    errorMessage: "phone number is required",
                  },
                }}
              />
            </Col>
          </Row>

          {!updateData?._id ? (
            <>
              <Row></Row>
            </>
          ) : (
            ""
          )}

          <div className="d-flex justify-content-end align-items-center">
            <div className="text-center mt-3">
              <button
                type="button"
                className="btn btn-light ms-2"
                onClick={onCloseClick}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-warning ms-2">
                {updateData?._id ? "Save" : "Create"}
              </button>
            </div>
          </div>
        </AvForm>
      </ModalBody>
    </Modal>
  )
}

FollowUpModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  updateData: PropTypes.any,
  type: PropTypes.any,
}

export default FollowUpModal
